module.exports = __webpack_public_path__ + "media/application/images/demo/content_8-d33bb978d598ed8dd74da58d005119da.jpg";